import Call from '../Call';
import {objToQs} from '../Utils';

const BidderCtr = {
    get(filters) {
        return Call(`bidderCtr?${objToQs(filters)}`);
    },

    getAffids(filters) {
        return Call(`bidderCtr/affid?${objToQs(filters)}`);
    }
};

export default BidderCtr;


// WEBPACK FOOTER //
// ./src/services/API/components/BidderCtr.js